import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUSES = ["new", "contacted", "in-progress", "closed"];

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = useCallback(() => api.get("/admin/inquiries").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    await api.put(`/admin/inquiries/${id}`, { status });
    toast.success("Status updated");
    load();
  };

  return (
    <div data-testid="admin-inquiries">
      <h1 className="font-serif text-4xl text-espresso">Business Inquiries</h1>
      <p className="text-espresso/60 mt-2">{items.length} total</p>

      <div className="mt-8 space-y-4">
        {items.length === 0 && <p className="text-espresso/50">No inquiries yet.</p>}
        {items.map((it) => (
          <div key={it.id} className="bg-taupe rounded-2xl p-6" data-testid={`inquiry-row-${it.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <h3 className="font-serif text-xl text-espresso">{it.company_name}</h3>
                <p className="text-espresso/70 text-sm">{it.contact_name} · {it.email} {it.phone && `· ${it.phone}`}</p>
                <p className="text-espresso/50 text-xs mt-1">{new Date(it.created_at).toLocaleString()}</p>
              </div>
              <select value={it.status} onChange={(e) => setStatus(it.id, e.target.value)} data-testid={`inquiry-status-${it.id}`}
                className="bg-ivory border border-champagne/40 rounded-lg px-3 py-2 text-sm text-espresso">
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <button onClick={() => setOpen(open === it.id ? null : it.id)} className="text-champagne text-sm mt-3 hover:text-espresso transition-colors">
              {open === it.id ? "Hide details" : "View details"}
            </button>
            {open === it.id && (
              <div className="mt-4 grid md:grid-cols-2 gap-4 text-sm text-espresso/80 border-t border-champagne/30 pt-4">
                <p><span className="text-espresso/50">Size:</span> {it.company_size || "—"}</p>
                <p><span className="text-espresso/50">Engagement:</span> {it.engagement_model || "—"}</p>
                <p><span className="text-espresso/50">Budget:</span> {it.budget || "—"}</p>
                <p><span className="text-espresso/50">Timeline:</span> {it.timeline || "—"}</p>
                <p className="md:col-span-2"><span className="text-espresso/50">Services:</span> {(it.services || []).join(", ") || "—"}</p>
                <p className="md:col-span-2"><span className="text-espresso/50">Goals:</span> {it.project_goals}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
